<template>
  <div
    :class="[
      'main-bage',
      {
        'main-bage_primary': variant === 'primary',
        'main-bage_danger': variant === 'danger',
        'main-bage_success': variant === 'success',
        'main-bage_warning': variant === 'warning',
      },
    ]"
  >
    {{ content }}
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      require: true,
    },
    variant: {
      type: String,
      require: false,
      default: "primary",
    },
  },
};
</script>

<style scoped>
.main-bage {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 6px;
  border-radius: 24px;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  white-space: nowrap;
  max-height: 18px;
}
.main-bage_success {
  background: var(--green-1-color);
  color: var(--green-7-color);
  border: 1px solid var(--green-5-color);
}
.main-bage_danger {
  background: var(--red-1-color);
  color: var(--red-7-color);
  border: 1px solid var(--red-5-color);
}
.main-bage_primary {
  background: var(--grey-2-color);
  color: var(--grey-3-color);
  border: 1px solid var(--grey-3-color);
}
.main-bage_warning {
  background: var(--yellow-1-color);
  color: var(--yellow-9-color);
  border: 1px solid var(--yellow-7-color);
}
</style>
;
